import type { CastId } from "../../engine";

export type LadoDeDialogo = "izquierda" | "derecha";

/** Capi representa la voz del jugador; los NPC le hablan desde el lado opuesto. */
export function ladoParaVozUnica(speaker: CastId): LadoDeDialogo {
  return speaker === "capi" ? "izquierda" : "derecha";
}
